export enum IssueSupportTemplatePermissions {
  ALL = "Travel:IssueSupportTemplates:*",
  READ = "Travel:IssueSupportTemplates:Read",
  WRITE = "Travel:IssueSupportTemplates:Write",
}

export function hasIssueSupportTemplateAccess(userPermissions: string[]): boolean {
  const permissions = [
    IssueSupportTemplatePermissions.READ.toString(),
    IssueSupportTemplatePermissions.WRITE.toString(),
    IssueSupportTemplatePermissions.ALL.toString(),
    "*",
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
